<template>
  <div class="dropdown more-filters float-right btn-group" role="group" aria-expanded="false" ref='dropdown' v-click-outside='closeDropdown'>
    <button @click='showFilter = null' class="btn btn-neutral" type="button" data-toggle="dropdown">
      {{ $t('root.filters.more_filters') }}
    </button>

    <div class="dropdown-menu">
      <div v-show='!showFilter'>
        <input v-model='q' type="search" class="form-control" />

        <ul>
          <li v-for='(name, filter) in filteredFilterList' :key='filter' @click='showFilter = filter' class="dropdown-item">
            {{ name }}
          </li>
        </ul>
      </div>

      <component v-if='showFilter' :is="'filter-items-by-' + showFilter" :folder='folder' @cancel='showFilter = null' />
    </div>
  </div>
</template>

<script>
  import _filter_items_by_type from './_filter_by_type'
  import _filter_items_by_contact from './_filter_by_contact'
  import _filter_items_by_ocr from './_filter_by_ocr'
  import _filter_items_by_mime from './_filter_by_mime'
  import _filter_items_by_size from './_filter_by_size'
  import _filter_items_by_uploaded_from from './_filter_by_uploaded_from'
  import _filter_items_by_deleted_at from './_filter_by_deleted_at'
  import _filter_items_by_deleted_by from './_filter_by_deleted_by'

  export default {
    components: {
      'filter-items-by-contact': _filter_items_by_contact,
      'filter-items-by-deleted_at': _filter_items_by_deleted_at,
      'filter-items-by-deleted_by': _filter_items_by_deleted_by,
      'filter-items-by-ocr': _filter_items_by_ocr,
      'filter-items-by-filesize': _filter_items_by_size,
      'filter-items-by-mime': _filter_items_by_mime,
      'filter-items-by-klass': _filter_items_by_type,
      'filter-items-by-uploaded_from': _filter_items_by_uploaded_from,
    },
    props: {
      folder: {
        type: Object,
        required: true,
      },
    },
    mounted() {
      $(this.$refs.dropdown).on('hide.bs.dropdown', () => {
        if (!this.isClosable)
          return false

        this.isClosable = false
        return true
      })
    },
    data() {
      return {
        q: '',
        showFilter: null,
        isClosable: false,
      }
    },
    computed: {
      upperQ() {
        return this.q.toUpperCase()
      },
      filterList() {
        return {
          contact: this.$t('root.filters.contact_connection'),
          deleted_at: this.$t('root.filters.deleted_at'),
          deleted_by: this.$t('root.filters.deleted_by'),
          ocr: this.$t('root.filters.ocr'),
          filesize: this.$t('root.filters.size'),
          mime: this.$t('root.filters.mime'),
          klass: this.$t('root.filters.show_only'),
          uploaded_from: this.$t('root.filters.uploaded_from'),
        }
      },
      filteredFilterList() {
        if (this.q.length < 1)
          return this.filterList

        const fs = {}
        Object.keys(this.filterList).forEach((k) => {
          const v = this.filterList[k]

          if (v.toUpperCase().indexOf(this.upperQ) >= 0)
            fs[k] = v
        })
        return fs
      },
    },
    methods: {
      closeDropdown() {
        if (this.$refs.dropdown.classList.contains('show'))
          this.isClosable = true
      },
    }
  }
</script>
<style lang="sass" scoped>
  .dropdown-menu
    padding: 10px
    .dropdown-item
      cursor: pointer
  .more-filters
    position: relative
    .btn.btn-neutral
      border-radius: 3px
    .dropdown-menu
      transform: none!important
      top: 45px!important
</style>
